"use client";

import React, { useEffect, useState } from "react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function UspSlider() {
  const { topbarMessages } = useSiteSettings();
  const messages = topbarMessages?.length ? topbarMessages : ["Voor 16:00 uur besteld, vandaag verzonden"];
  const [i, setI] = useState(0);

  useEffect(() => {
    setI(0);
  }, [messages.length]);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % messages.length), 4000);
    return () => clearInterval(t);
  }, [messages.length]);

  return (
    <div className="announcement-bar" aria-live="polite" style={{ overflow: "hidden", height: "auto" }}>
      <span key={i} style={{ display: "inline-block", animation: "uspFade 0.6s ease" }}>
        {messages[i]}
      </span>
      <style>{`@keyframes uspFade { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
}
